import React from "react";
import EventUserAvailabilityToggle from "../../EventUser/EventUserAvailabilityToggle";
import { isMobileOrTablet } from "../../Views/MobileClassRenderer";

export default function Dropdownitem({ label, children }) {
  
  const dropItemMobileInline = isMobileOrTablet
    ? { display: "flex", alignItems: "center", position: "relative", justifyContent: "space-between", padding: "0 1rem" }
    : "";

  return (
    <div className="nav-dropdown-item" style={dropItemMobileInline}>
      <div style={{ fontSize: isMobileOrTablet ? "12px" : "inherit" }}>
        {label}
      </div>
      <div className={`${isMobileOrTablet() ? "toggle-div" : ""}`}>{children}</div>
    </div>
  );
}
